<template>
  <div class="wrapper flex w-12 p-3 justify-content-between" :class="{'mt-3':tenant=='admin'}">
    <div>
      <ClientOnly>
        <Breadcrumb v-if="items?.length && leafId" :home="home" :model="items" class="bg-none p-0">
          <template #item="{ item, props }">
            
            <router-link v-if="item.route" v-slot="{ href, navigate }" :to="useCurrentRoute(item)" custom>
              <a :href="href" v-bind="props.action" @click="navigate">
                <span :class="[item.icon, 'text-color']" />
                <span class="text-primary font-semibold">{{ item.label }}</span>
              </a>
            </router-link>
            <a v-else :href="item.url" :target="item.target" v-bind="props.action">
              <span class="text-color">{{ item.label }}</span>
            </a>
          </template>
        </Breadcrumb>
      </ClientOnly>
    </div>
    <div class="flex gap-4 align-items-center menu-icons">
      <div v-if="tenant=='admin' && tenantListDropdownData?.length">
        <FloatLabel>
          <Dropdown id="tenants-dropdown" v-model="currentTenantModel" :options="tenantListDropdownData" optionLabel="name" showClear placeholder="Seleziona un tenant" class="w-full md:w-14rem" @change="currentTenant = currentTenantModel.code" />
          <label for="tenants-dropdown">Organizzazione</label>
      </FloatLabel>

      </div>
      <!-- <button type="button" class="layout-topbar-action" @click="toggleDarkMode">
        <i :class="['pi', { 'pi-moon': isDarkMode, 'pi-sun': !isDarkMode }]"></i>
      </button> -->
      <!-- <div class="cursor-pointer" @click="showNotify = !showNotify">
        <i class="pi pi-bell text-xl"></i>
      </div> -->
      <div class="relative">
        <button
          @click="showProfileMenu = !showProfileMenu"
          type="button" class="layout-topbar-action layout-topbar-action-highlight border-none bg-none">
            <Avatar 
            v-if="data && data.user" 
            :label="`${(data.user as unknown as UserType).name[0]}${(data.user as unknown as UserType).surname[0]}`" 
            class="cursor-pointer mr-2 bg-blue-400 text-white" 
            size="normal"
            shape="circle"
          />
        </button>
        <ProfileMenu v-if="showProfileMenu" class="mt-3" />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { UserType } from '~/types/user';
import { capitalize, map, find } from 'lodash-es';
import { useGeneralStore } from '@/composables/useGeneralStore';
import type { DynamicsType } from '~/server/types/dynamics';


const { data, getSession } = useAuth();
const tenant = useTenant();
const { leafId, leafName } = useBreadcrumb();
const { toggleDarkMode, isDarkMode } = useLayout();
const {public: config} = useRuntimeConfig();
const route = useRoute();
const showNotify = ref(false);
const showProfileMenu = ref(false);
const showProfile = ref(false);
const app = useState('app');
const currentTenantModel = ref();
const {tenantList,currentTenant} = useAdminTenant();
const userMenu = ref();
const {getMenuItems} = useSchema();
const home = ref({
  icon: 'pi pi-home',
  route: `/${app.value}`
});
const knownRoutes = await getMenuItems();
const menuItems = ref([
  { key: 'edit', label: 'Modifica', icon: 'pi pi-file-edit' },
  // { key: 'clone', label: 'Duplica', icon: 'pi pi-copy' },
  { key: 'logout', label: 'Logout', icon: 'pi pi-sign-out' },
])
const useCurrentRoute = (item: any) => {
  return `/${useGeneralStore().app.value}${item.route!='/procedure'?item.route:''}`;
}
const items = computed(() => {
  const paths = route.path.split('/').filter(Boolean);
  if (paths.length && paths[0] === app.value) paths.shift();

  const items = paths.map((path, index) => {
    const route = '/' + paths.slice(0, index + 1).join('/');
    const foundKnownRoute = find(knownRoutes,{table: path});
    if(foundKnownRoute){
      path = (foundKnownRoute as DynamicsType).name || path;
    }
    return {
      label: leafId.value === path ? leafName.value : path,
      route: route
    };
  });
  return items;
});

const onContextClick = (item: any) => {
  switch (item.key) {
    case 'edit':
      /* TODO: what is editDocument() pointing at? */
      // editDocument();
      break;
    case 'clone':
      break;
    case 'delete':
      break;
  }
};

const tenantListDropdownData = computed(() => {
  return map(tenantList.value,(v:any) => {
    return {
      name: v.name,
      code: v.dbName,
    }
  })
});

watch(data, (v) => {
  if (!v) {
    getSession({
      onUnauthenticated: () => {
        return navigateTo(`${config.baseURL}/login`);
      }
   });
  }
});
</script>
<style scoped lang="scss">
.wrapper {
  height: 60px;
}
.menu-icons{
  button {
    border: none;
    cursor: pointer;
    background: none;
  }
}
</style>